import { createI18n } from 'vue-i18n';
import it from './it.json';
import en from './en.json';

const messages = {
  it,
  en
}

const languages = [
  {
    code: 'it',
    label: 'Italiano',
    flag: 'fi-it'
  },
  {
    code: 'en',
    label: 'English',
    flag: 'fi-gb'
  },
];

const i18n = createI18n({
  locale: 'it',
  fallbackLocale: 'it',
  messages,
  legacy: false
})


export default {
  install: (app, options) => {
    app.provide('languages', languages);
    app.use(i18n);
  }
}